import { normalizePersianZoneText } from './persianTerminology';

/** Validate API/cache leaves before allowing them to override shipped copy. */
export function validatedRemoteTranslations(
  locale: string,
  bundled: Record<string, unknown>,
  remote: Record<string, unknown>,
  path: string[] = [],
): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  const tokens = (s: string) => (s.match(/{{\s*[^}]+\s*}}/g) ?? []).sort().join('|');
  for (const [key, value] of Object.entries(remote)) {
    if (['__proto__', 'constructor', 'prototype'].includes(key)) continue;
    const local = bundled[key];
    const fullKey = [...path, key].join('.');
    if (locale === 'fa' && ['sidebar.nav.charts', 'sidebar.nav.workoutBuilder', 'workoutDetail.map.smoothLevel'].includes(fullKey) && typeof local === 'string') {
      result[key] = local;
      continue;
    }
    if (typeof value === 'string' && value.trim()) {
      if (typeof local === 'string' && tokens(local) !== tokens(value)) continue;
      if (locale === 'fa' && typeof local === 'string' && /[\u0621-\u064aپچژگکی]/.test(local)) {
        // Reject old Latin-only labels when Persian copy is bundled.
        if (!/[\u0621-\u064aپچژگکی]/.test(value)) continue;
      }
      if (locale === 'ar' && typeof local === 'string' && /[\u0621-\u064a]/.test(local)) {
        // Old seeds contained English placeholders; never restore those from cache.
        if (!/[\u0621-\u064a]/.test(value) || /[پچژگکی]/.test(value)) continue;
      }
      if (local === undefined || typeof local === 'string') result[key] = locale === 'fa' ? normalizePersianZoneText(value).replace(/فشار تمرین/g, 'بار تمرین') : value;
    } else if (value && typeof value === 'object' && !Array.isArray(value)) {
      if (local !== undefined && (!local || typeof local !== 'object' || Array.isArray(local))) continue;
      result[key] = validatedRemoteTranslations(locale, (local ?? {}) as Record<string, unknown>, value as Record<string, unknown>, [...path, key]);
    }
  }
  return result;
}
